import { combineReducers } from "redux";
import Storage from "../utils/storage";
import DashboardPagesReducer from "../reducers/dashboard";

function settingsReducer() {
  const GENERAL_SETTING_INITIAL_STATE = {
    isDarkMode: true,
    savable: true,
    prevRoute: null,
    isWizardAccordionFolded:
      localStorage.getItem("isWizardAccordionFolded") === "true",
  };
  const ASSOCIATE_PRODUCTS_INITIAL_STATE = {
    sensorsList: null,
    spaAllFields: null,
    adminBaseEvents: null,
    motionSensorCapabilityValues: null,
    alertPredicateBehaviors: null,
  };
  const MODULES_LIST_INITIAL_STATE = [];
  const USER_ADMINISTRATION = {
    users: null,
    timeZones: null,
    states: null,
    types: null,
    statuses: null,
  };

  const generalSetting = (state = GENERAL_SETTING_INITIAL_STATE, action) => {
    switch (action.type) {
      case "SETTINGS_UPDATE":
        return { ...state, [action.setting]: action.value };
      case "SETTINGS_INITIAL_LOAD":
        const storedSettings = Storage.getItem("app-settings");
        return { ...state, ...storedSettings };
      default:
        return state;
    }
  };

  const userAdministration = (state = USER_ADMINISTRATION, action) => {
    switch (action.type) {
      case "UPDATE_USERS_ADMINISTRATION":
        return { ...state, users: action.payload };
      case "UPDATE_USERS_ADMINISTRATION_STATES":
        return { ...state, states: action.payload };
      case "UPDATE_USERS_ADMINISTRATION_TIME_ZONES":
        return { ...state, timeZones: action.payload };
      case "UPDATE_USERS_ADMINISTRATION_TYPES":
        return { ...state, types: action.payload };
      case "UPDATE_USERS_ADMINISTRATION_STATUSES":
        return { ...state, types: action.payload };
      default:
        return state;
    }
  };

  const sensorsList = (
    state = ASSOCIATE_PRODUCTS_INITIAL_STATE.sensorsList,
    action,
  ) => {
    switch (action.type) {
      case "SENSORS_LIST_INIT":
        return null;
      case "SENSORS_LIST_SUCCESS":
        return action.payload;
      case "UPDATE_SENSORS_LIST":
        return action.payload;
      default:
        return state;
    }
  };

  const spaAllFields = (
    state = ASSOCIATE_PRODUCTS_INITIAL_STATE.spaAllFields,
    action,
  ) => {
    switch (action.type) {
      case "SPA_ALL_FIELDS_INIT":
        return null;
      case "SPA_ALL_FIELDS_SUCCESS":
        return action.payload;
      case "UPDATE_SPA_ALL_FIELDS":
        return action.payload;
      default:
        return state;
    }
  };

  const motionSensorCapabilityValues = (
    state = ASSOCIATE_PRODUCTS_INITIAL_STATE.motionSensorCapabilityValues,
    action,
  ) => {
    switch (action.type) {
      case "MOTION_SENSOR_CAPABILITY_VALUES_INIT":
        return null;
      case "MOTION_SENSOR_CAPABILITY_VALUES_SUCCESS":
        return action.payload;
      case "UPDATE_MOTION_SENSOR_CAPABILITY_VALUES":
        return action.payload;
      default:
        return state;
    }
  };

  const adminBaseEvents = (
    state = ASSOCIATE_PRODUCTS_INITIAL_STATE.adminBaseEvents,
    action,
  ) => {
    switch (action.type) {
      case "ADMIN_BASE_EVENTS_INIT":
        return null;
      case "ADMIN_BASE_EVENTS_SUCCESS":
        return action.payload;
      case "UPDATE_ADMIN_BASE_EVENT":
        return action.payload;
      default:
        return state;
    }
  };

  const alertPredicateBehaviors = (
    state = ASSOCIATE_PRODUCTS_INITIAL_STATE.alertPredicateBehaviors,
    action,
  ) => {
    switch (action.type) {
      case "ALERT_PREDICATE_BEHAVIORS_INIT":
        return null;
      case "ALERT_PREDICATE_BEHAVIORS_SUCCESS":
        return action.payload;
      case "UPDATE_ALERT_PREDICATE_BEHAVIOR":
        return action.payload;
      default:
        return state;
    }
  };

  const applicationModulesList = (
    state = MODULES_LIST_INITIAL_STATE,
    action,
  ) => {
    switch (action.type) {
      case "MODULES_LIST_INITIAL_STATE_INIT":
        return [];
      case "MODULES_LIST_INITIAL_STATE_SUCCESS":
        return action.payload;
      default:
        return state;
    }
  };

  return combineReducers({
    generalSetting,
    userAdministration,
    applicationSetting: combineReducers({
      associateProducts: combineReducers({
        sensorsList,
        spaAllFields,
        adminBaseEvents,
        alertPredicateBehaviors,
        motionSensorCapabilityValues,
      }),
      applicationModulesList,
    }),
    dashboard: DashboardPagesReducer,
  });
}
export default settingsReducer();
